const HANDLED_MEDIA_ACCESS_ERROR_NAMES = new Set([
  'NotAllowedError',
  'OverconstrainedError',
  'AbortError',
  'NotFoundError',
  'DevicesNotFoundError',
  'NotReadableError',
  'TrackStartError',
]);

export const isHandledMediaAccessError = (error: unknown): error is DOMException => {
  const errorName = typeof error === 'object' && error && 'name' in error ? String(error.name) : '';
  return HANDLED_MEDIA_ACCESS_ERROR_NAMES.has(errorName);
};
